import React, { useEffect, useRef, useState } from 'react';

interface MarketEventsProps {
    compact?: boolean;
}

const MarketEvents: React.FC<MarketEventsProps> = ({ compact = false }) => {
    const [activeTab, setActiveTab] = useState<'economic' | 'earnings'>('economic');
    const economicContainer = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Economic Calendar Widget
        if (activeTab === 'economic' && economicContainer.current) {
            economicContainer.current.innerHTML = ''; // Clear previous
            const script = document.createElement('script');
            script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-events.js';
            script.async = true;
            script.innerHTML = JSON.stringify({
                "colorTheme": "dark",
                "isTransparent": true,
                "width": "100%",
                "height": "100%",
                "locale": "en",
                "importanceFilter": "0,1",
                "currencyFilter": "USD"
            });
            economicContainer.current.appendChild(script);
        }

        // Earnings Calendar Widget (placeholder/future implementation)

    }, [activeTab]);

    const tabSwitcher = (
        <div className="flex items-center gap-1 bg-black/20 rounded-lg p-1">
            <button
                onClick={() => setActiveTab('economic')}
                className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all ${activeTab === 'economic'
                    ? 'bg-neon/10 text-neon shadow-xs'
                    : 'text-muted hover:text-white hover:bg-white/5'
                    }`}
            >
                Economic
            </button>
            <button
                onClick={() => setActiveTab('earnings')}
                className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all ${activeTab === 'earnings'
                    ? 'bg-neon/10 text-neon shadow-xs'
                    : 'text-muted hover:text-white hover:bg-white/5'
                    }`}
            >
                Earnings
            </button>
        </div>
    );

    return (
        <div className={`${compact ? 'h-[68vh]' : 'h-full p-6'} flex flex-col`}>
            <div className={`flex-1 flex flex-col relative ${compact ? 'min-h-[420px]' : 'panel min-h-[600px]'}`}>
                {compact ? (
                    <div className="flex items-center justify-end border-b border-white/10 px-3 py-3">
                        {tabSwitcher}
                    </div>
                ) : (
                    <div className="px-4 py-4 flex items-center justify-between border-b border-white/10 bg-white/5">
                        <div className="space-y-1">
                            <h2 className="font-semibold text-neon flex items-center gap-2">
                                Market Events
                            </h2>
                            <p className="text-xs text-muted">Economic calendar and future releases</p>
                        </div>
                        {tabSwitcher}
                    </div>
                )}

                {/* Content Area */}
                <div className="flex-1 relative bg-surface/50">
                    {activeTab === 'economic' && (
                        <div className="tradingview-widget-container absolute inset-0 w-full h-full" ref={economicContainer}>
                            <div className="tradingview-widget-container__widget h-full w-full"></div>
                            <div className="tradingview-widget-copyright">
                                <a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank">
                                    <span className="blue-text">Track all markets on TradingView</span>
                                </a>
                            </div>
                        </div>
                    )}

                    {activeTab === 'earnings' && (
                        <div className="absolute inset-0 flex items-center justify-center text-muted flex-col gap-2">
                            <p>Earnings calendar coming soon</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MarketEvents;
